export default (user) => {
    if (user.employee) {
        return user.firstName + ' ' + user.lastName
    }
    return user.firstName + ' ' + user.lastName + ' (External)'
}



// WEBPACK FOOTER //
// ./src/modules/security/component/manage/renderUserName.js